// extracted by mini-css-extract-plugin
module.exports = {"inputGrid":"input-grid_inputGrid__3kqTb"};